/**
 * 常量定义
 */
export default {
  TEST: 'TEST Value'
}
